import hrApi from '@/api/v1/hr';

export default {
  namespaced: true,

  state: {
    projectData: {
      name: '',
      team_size: '',
      start_date: '',
      end_date: '',
      technologies: [],
      management: [],
      project_areas: [],
      contracts: [],
      recruitments: [],
      notes: '',
      attachments: [],
      id: '',
      assigned_hr: {},
      assigned_hr_id: '',
      available_hrs: [],
      client_first_name: '',
      client_last_name: '',
    },

    projectRecentSummary: {
      current_month: '',
      summary: {
        amount: null,
        amount_change: null,
        contracts_size: null,
        time: null,
        time_change: null,
      },
    },

    projectFinance: {
      current_month: {},
      months: [],
      reports: [],
      summary: {
        amount: null,
        amount_change: null,
        contracts_size: null,
        time: null,
        time_change: null,
      },
      navigation: {
        project: {
          name: '',
        },
      },
    },

    isDataLoading: false,
    isSubmitProcessing: false,
  },

  mutations: {
    CHANGE_PROJECT(state, projectData) {
      state.projectData = { ...projectData };
    },

    CHANGE_LOADING_STATUS(state, status) {
      state.isDataLoading = status;
    },

    CHANGE_SUBMIT_STATUS(state, status) {
      state.isSubmitProcessing = status;
    },

    CHANGE_RECENT_SUMMARY(state, summaryData) {
      state.projectRecentSummary = { ...summaryData };
    },

    CHANGE_FINANCE_SUMMARY(state, summaryData) {
      state.projectFinance = { ...summaryData };
    },

    CHANGE_NOTES(state, notes) {
      state.projectData.notes = notes;
    },

    CHANGE_ASSIGNED_HR(state, id) {
      state.projectData.assigned_hr_id = id;
    },
  },

  actions: {
    fetchProject({ commit }, projectId) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .show(projectId)
          .then((resp) => {
            commit('CHANGE_PROJECT', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    updateProject({ commit, dispatch }, projectData) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .update(projectData.id, projectData)
          .then((resp) => {
            commit('CHANGE_PROJECT', resp.data);
            dispatch('showSuccess', ['Updated'], { root: true });
            resolve();
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    deleteProjectContract({ dispatch }, contractParams) {
      return new Promise((resolve, reject) => {
        hrApi.contracts
          .delete(contractParams.projectId, contractParams.id)
          .then((resp) => {
            dispatch('showSuccess', ['Contract deleted'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },

    updateProjectContract({ dispatch }, contractParams) {
      return new Promise((resolve, reject) => {
        hrApi.contracts
          .update(contractParams.projectId, contractParams.data.id, contractParams.data)
          .then((resp) => {
            dispatch('showSuccess', ['Contract updated'], { root: true });
            resolve(resp);
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          });
      });
    },


    fetchProjectRecentSummary({ commit }, projectId) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .recentSummary(projectId)
          .then((resp) => {
            commit('CHANGE_RECENT_SUMMARY', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    fetchProjectFinance({ commit }, projectParams) {
      commit('CHANGE_LOADING_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .getReport(projectParams.id, { date: projectParams.date })
          .then((resp) => {
            commit('CHANGE_FINANCE_SUMMARY', resp.data);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_LOADING_STATUS', false);
          });
      });
    },

    updateProjectReport({ commit }, reportParams) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .updateReport(reportParams.id, reportParams.data)
          .then(() => {
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },

    updateNotes({ commit, dispatch }, params) {
      return new Promise((resolve, reject) => {
        hrApi.projects
          .update(params.id, params)
          .then((resp) => {
            commit('CHANGE_PROJECT', resp.data);
            dispatch('showSuccess', ['Updated'], { root: true });
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    deleteProject({ commit, dispatch }, projectId) {
      commit('CHANGE_SUBMIT_STATUS', true);

      return new Promise((resolve, reject) => {
        hrApi.projects
          .delete(projectId)
          .then((resp) => {
            resolve(resp);
            dispatch('showSuccess', ['Deleted'], { root: true });
          })
          .catch((err) => {
            dispatch('showError', err.response.data.errors, { root: true });
            reject();
          })
          .finally(() => {
            commit('CHANGE_SUBMIT_STATUS', false);
          });
      });
    },


    updateHr({ commit }, id) {
      commit('CHANGE_ASSIGNED_HR', id);
    },

    addProjectNotes({ commit }, notes) {
      commit('CHANGE_NOTES', notes);
    },
  },
};
